import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { Input } from "@angular/core";
import { DebugService } from "../../../../../app/_core/services/debug.service";
import { Router } from "@angular/router";

@Component({
    selector: "dodo-address-bar",
    templateUrl: "./address-bar.component.html",
    styleUrls: ["./address-bar.component.scss"],
    standalone: false
})
export class AddressBarComponent implements OnInit {
	@Input()
	address: String;
	@Input()
	label: String;
	@Input()
	url: String = "#";
	@Input()
	fullWidth: Boolean = false;
	@Output() changeAddressClicked = new EventEmitter();

	constructor(private log: DebugService, private router: Router) {}

	ngOnInit() {}

	changeAddress() {
		this.changeAddressClicked.emit();
	}
}
